import { IRevenueAgencyCrudModalLang } from '../../../types/lang'

export const revenueAgencyCrudModalLang: IRevenueAgencyCrudModalLang = {
	revenue_agency_crud_modal: {
		title_create: 'Create revenue agency_ua',
		title_edit: 'Edit revenue agency_ua',
		title_remove_single: 'Remove <span>revenue agency_ua</span>',
		title_notes_view: 'View notes for revenue agency_ua',
		title_notes_edit: 'Edit notes for revenue agency_ua',
		title_history_view: 'View history in revenue agency_ua',
		field_name_label: 'Name_ua',
		field_name_placeholder: 'Name_ua',
		field_group_label: 'Group_ua',
		field_group_placeholder: 'Group_ua',
		field_fake_type_label: 'Fake Type_ua',
		field_fake_type_placeholder: 'Fake Type_ua',
		field_date_label: 'Date_ua',
		field_date_placeholder: 'Date_ua',
		field_percent_label: 'Percent, %_ua',
		field_percent_placeholder: 'Percent, %_ua',
		field_is_system_label: 'System_ua',
		field_is_active_label: 'Active_ua',
		field_is_hold_label: 'Hold_ua',
		field_notes_label: 'Notes_ua',
		field_notes_placeholder: 'Notes_ua',
		msg_remove_confirm: 'Are you sure?_ua',
		btn_add_record: 'Add Record_ua',
		btn_create: 'Create_ua',
		btn_update: 'Save_ua',
		btn_remove: 'Remove_ua',
		btn_close: 'Close_ua'
	}
}